import { LocalDictionaryFactory } from '../../api/api.module'

import { LoggerService } from '../../common/common.module'
import { ConsumerDetailsDirectiveController } from './consumers-details.directive.controller'

import { IUserSession } from '../../../helpers/user-session'
import { ConsumerHelper } from '../consumers.helper'

//#region Asset Imports

import './consumers-details.scss'
import * as TEMPLATE from './consumers-details.tpl.html'

//#endregion

// #region Consts

const TEMPLATE_PATH: string = `./${ConsumerHelper.FILE_NAME_PREFIX}-details.tpl.html`

// #endregion


// #region Setup

export class ConsumerDetailsDirective implements ng.IDirective {

    restrict = 'E'

    scope = {
        id: '='
    }

    controller = ['$scope', '$q', '$timeout', 'logger', 'localDictionary', 'userSession', (
        $scope: any,
        $q: ng.IQService,
        $timeout: ng.ITimeoutService,
        logger: LoggerService,
        localDictionary: LocalDictionaryFactory,
        userSession: IUserSession
    ) => new ConsumerDetailsDirectiveController(
        $scope,
        $q,
        $timeout,
        logger,
        localDictionary,
        userSession,
        ConsumerHelper.REFERENCE_TYPE,
        ConsumerHelper.SIMAX_MODULE_NAME
    )]

    template = TEMPLATE
}

// #endregion